// AWS S3 configuration
const bucket = process.env.REACT_APP_S3_BUCKET;
const region = process.env.REACT_APP_S3_REGION;

// Helper function to build S3 photo URLs
const getS3PhotoUrl = (folderName, photoFileName) => {
  return `https://${bucket}.s3.${region}.amazonaws.com/${folderName}/${photoFileName}`;
};

// Function to fetch photos from S3
// Uses S3 ListObjects API to fetch all photos automatically
export const fetchS3Photos = async (folderName) => {
  try {
    // S3 bucket and region from environment
    const url = `https://${bucket}.s3.${region}.amazonaws.com/?prefix=${folderName}/&list-type=2`;
    
    const response = await fetch(url);
    const xmlText = await response.text();
    
    // Parse XML response to extract file keys
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlText, 'text/xml');
    
    // Get all contents elements
    const contents = xmlDoc.getElementsByTagName('Contents');
    const photoUrls = [];
    
    for (let i = 0; i < contents.length; i++) {
      const key = contents[i].getElementsByTagName('Key')[0]?.textContent;
      
      // Skip folder itself, only include actual files
      if (key && key !== folderName + '/' && !key.endsWith('/')) {
        const fileExtension = key.split('.').pop().toLowerCase();
        // Only include image files
        if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension)) {
          photoUrls.push(getS3PhotoUrl(folderName, key.split('/').pop()));
        }
      }
    }
    
    return photoUrls.sort(); // Sort alphabetically for consistency
  } catch (error) {
    console.warn(`Could not fetch photos from S3 folder ${folderName}:`, error);
    return [];
  }
};

export const TRIPS_DATA = [
  {
    id: "world-2002-2003",
    title: "Around the World: 2002-2003",
    date: "2002-2003",
    description: "A year-long journey across continents",
    aboutText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    heroImage: "https://images.unsplash.com/photo-1488646953014-85cb44e45828?w=1200&h=600&fit=crop",
    majorLocations: [
      { id: "thailand", name: "Thailand", lat: 15.8700, lng: 100.9925 },
      { id: "india", name: "India", lat: 20.5937, lng: 78.9629 },
      { id: "southafrica", name: "South Africa", lat: -30.5595, lng: 22.9375 },
    ],
    locations: [
      {
        id: "home-and-cooks",
        title: "Home & Cooks",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        coordinates: { lat: 40.7128, lng: -74.0060 },
        importantSpots: [],
        s3FolderName: "001home_and_cooks",
        photos: []
      },
      {
        id: "new-zealand",
        title: "New Zealand",
        description: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.",
        coordinates: { lat: -40.9006, lng: 174.8860 },
        importantSpots: [
          { name: "Auckland", lat: -37.0082, lng: 174.7850 },
          { name: "Milford Sound", lat: -44.6719, lng: 168.0213 },
        ],
        s3FolderName: "002new_zealand",
        photos: []
      },
      {
        id: "australia",
        title: "Australia",
        description: "Duis aute irure dolor in reprehenderit in voluptate velit esse.",
        coordinates: { lat: -25.2744, lng: 133.7751 },
        importantSpots: [
          { name: "Sydney", lat: -33.8688, lng: 151.2093 },
          { name: "Great Barrier Reef", lat: -18.2871, lng: 147.6992 },
        ],
        s3FolderName: "003australia",
        photos: []
      },
      {
        id: "nepal",
        title: "Nepal",
        description: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia.",
        coordinates: { lat: 28.3949, lng: 84.1240 },
        importantSpots: [
          { name: "Kathmandu", lat: 27.7172, lng: 85.3240 },
          { name: "Mount Everest", lat: 27.9881, lng: 86.9250 },
        ],
        s3FolderName: "004nepal",
        photos: []
      },
      {
        id: "thailand",
        title: "Thailand",
        description: "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        coordinates: { lat: 15.8700, lng: 100.9925 },
        importantSpots: [
          { name: "Bangkok", lat: 13.7563, lng: 100.5018 },
          { name: "Chiang Mai", lat: 18.7883, lng: 98.9853 },
        ],
        s3FolderName: "005thailand",
        photos: []
      },
      {
        id: "laos",
        title: "Laos",
        description: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit.",
        coordinates: { lat: 19.8523, lng: 102.4955 },
        importantSpots: [
          { name: "Luang Prabang", lat: 19.8845, lng: 102.1348 },
          { name: "Mekong River", lat: 16.2333, lng: 105.0333 },
        ],
        s3FolderName: "006laos",
        photos: []
      },
      {
        id: "vietnam",
        title: "Vietnam",
        description: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem.",
        coordinates: { lat: 14.0583, lng: 108.2772 },
        importantSpots: [
          { name: "Hanoi", lat: 21.0285, lng: 105.8542 },
          { name: "Ha Long Bay", lat: 20.8131, lng: 107.1827 },
        ],
        s3FolderName: "007vietnam",
        photos: []
      },
      {
        id: "cambodia",
        title: "Cambodia",
        description: "Accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae.",
        coordinates: { lat: 12.5657, lng: 104.9910 },
        importantSpots: [
          { name: "Siem Reap", lat: 13.3671, lng: 103.8448 },
          { name: "Angkor Wat", lat: 13.3627, lng: 103.8352 },
        ],
        s3FolderName: "008cambodia",
        photos: []
      },
      {
        id: "thailand-2nd",
        title: "Thailand (2nd Time)",
        description: "Nisi ut aliquid ex ea commodo consequat duis aute irure dolor.",
        coordinates: { lat: 15.8700, lng: 100.9925 },
        importantSpots: [
          { name: "Phuket", lat: 8.1093, lng: 98.3088 },
          { name: "Krabi", lat: 8.6195, lng: 98.9063 },
        ],
        s3FolderName: "009thailand_2nd_time",
        photos: []
      },
      {
        id: "india",
        title: "India",
        description: "In reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla.",
        coordinates: { lat: 20.5937, lng: 78.9629 },
        importantSpots: [
          { name: "Delhi", lat: 28.7041, lng: 77.1025 },
          { name: "Taj Mahal", lat: 27.1751, lng: 78.0421 },
        ],
        s3FolderName: "010india",
        photos: []
      },
      {
        id: "tanzania",
        title: "Tanzania",
        description: "Pariatur excepteur sint occaecat cupidatat non proident sunt in culpa.",
        coordinates: { lat: -6.3690, lng: 34.8888 },
        importantSpots: [
          { name: "Mount Kilimanjaro", lat: -3.0674, lng: 37.3556 },
          { name: "Serengeti", lat: -2.3333, lng: 34.8333 },
        ],
        s3FolderName: "011Tanzania",
        photos: []
      },
      {
        id: "kenya",
        title: "Kenya",
        description: "Qui officia deserunt mollit anim id est laborum sint occaecat.",
        coordinates: { lat: -0.0236, lng: 37.9062 },
        importantSpots: [
          { name: "Nairobi", lat: -1.2862, lng: 36.8172 },
          { name: "Masai Mara", lat: -1.5, lng: 35.0833 },
        ],
        s3FolderName: "012Kenya",
        photos: []
      },
      {
        id: "mauritius",
        title: "Mauritius",
        description: "Culpa qui officia deserunt mollit anim id est laborum dolore eu.",
        coordinates: { lat: -20.3484, lng: 57.5522 },
        importantSpots: [
          { name: "Port Louis", lat: -20.1609, lng: 57.5012 },
          { name: "Chamarel Waterfall", lat: -20.3828, lng: 57.3850 },
        ],
        s3FolderName: "013Mauritius",
        photos: []
      },
      {
        id: "south-africa",
        title: "South Africa",
        description: "Fugiat nulla pariatur excepteur sint occaecat cupidatat non proident.",
        coordinates: { lat: -30.5595, lng: 22.9375 },
        importantSpots: [
          { name: "Cape Town", lat: -33.9249, lng: 18.4241 },
          { name: "Table Mountain", lat: -33.9629, lng: 18.4102 },
        ],
        s3FolderName: "014SouthAfrica",
        photos: []
      },
      {
        id: "amsterdam",
        title: "Amsterdam",
        description: "Sunt in culpa qui officia deserunt mollit anim id est laborum.",
        coordinates: { lat: 52.3676, lng: 4.9041 },
        importantSpots: [
          { name: "Anne Frank House", lat: 52.3751, lng: 4.8841 },
          { name: "Canal Ring", lat: 52.3675, lng: 4.9100 },
        ],
        s3FolderName: "015Amsterdam",
        photos: []
      },
    ]
  },
];

